<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-left">
      <span class="copyright-text">&copy; {{ currentYear }} ElevateMe CRM. All rights reserved.</span>
    </div>
    <div class="footer-right">
      <span class="version-text">Version {{ version }}</span>
    </div>
  </div>
</footer>

